export default __webpack_public_path__ + "static/media/book.3a75684a.png";